import { SidebarItem } from '@backstage/core-components';
import type { IconComponent } from '@backstage/core-plugin-api';
import { MY_GROUPS_PATH } from '../../utils/myGroups';

type Props = {
  title: string;
  icon: IconComponent;
};

/** Sidebar link to the dedicated My Groups page (never a single group entity). */
export function IronPhoenixMyGroupsSidebarItem({ title, icon }: Props) {
  return <SidebarItem icon={icon} text={title} to={MY_GROUPS_PATH} />;
}
